// extracted by mini-css-extract-plugin
export default {"notFoundContainer":"NotFound_notFoundContainer__0UENZ","homeLink":"NotFound_homeLink__RiZL7"};